import {registerJQueryComponent} from '@lib/JQueryRegistry'

const DIRECTION_ASCENDING = 'ascending'
const DIRECTION_DESCENDING = 'descending'
const DIRECTION_DEFAULT = 'default'

export default class SortableTable {
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            headers: rootElement.find('thead th').toJQueryObjectsArray(),
            rows: rootElement.find('tbody tr').toJQueryObjectsArray(),
            rowsContainer: rootElement.find('tbody')
        }

        this.$state = {
            currentSortColumnIdx: null,
            currentSortOrder: ''
        }

        this.$dom.headers.forEach(this.initializeHeader)
    }

    initializeHeader = (header, idx) => {
        let sortable = header.data('sortable')
        if (sortable) {
            header.addClass('sortable-column-header')
            header.click(() => this.onColumnHeaderClick(header, idx))
        }
    }

    onColumnHeaderClick = (header, idx) => {

        // Deselect currently selected column.
        if (this.$state.currentSortColumnIdx !== null && this.$state.currentSortColumnIdx !== idx) {
            this.$dom.headers[this.$state.currentSortColumnIdx].removeClass('ascending')
            this.$dom.headers[this.$state.currentSortColumnIdx].removeClass('descending')
        }

        if (this.$state.currentSortColumnIdx !== idx) {
            this.$state.currentSortColumnIdx = idx
            this.$state.currentSortOrder = DIRECTION_DESCENDING

            header.addClass('descending')
            header.removeClass('ascending')
        } else {
            if (this.$state.currentSortOrder === DIRECTION_DESCENDING) {
                this.$state.currentSortOrder = DIRECTION_ASCENDING

                header.removeClass('descending')
                header.addClass('ascending')
            } else {
                this.$state.currentSortOrder = DIRECTION_DESCENDING

                header.removeClass('ascending')
                header.addClass('descending')
            }
        }

        this.sortTable(this.$state.currentSortColumnIdx + 1, this.$state.currentSortOrder)
    }

    sortTable = (columnIdx, direction) => {
        let rows = this.$dom.rows

        rows.forEach(row => {
            row.detach()
        })

        switch (direction) {
            case DIRECTION_ASCENDING: {
                rows = rows.sort((a, b) => {
                    a = $(a)
                    b = $(b)

                    let aValue = a.find('td:nth-child(' + columnIdx + ')').data('sort-value')
                    let bValue = b.find('td:nth-child(' + columnIdx + ')').data('sort-value')

                    if (typeof aValue === 'string' && typeof bValue === 'string') {
                        return -aValue.localeCompare(bValue)
                    }

                    return parseInt(aValue) - parseInt(bValue)
                })

                break;
            }

            case DIRECTION_DESCENDING:
            case DIRECTION_DEFAULT: {
                rows = rows.sort((a, b) => {
                    a = $(a)
                    b = $(b)

                    let aValue = a.find('td:nth-child(' + columnIdx + ')').data('sort-value')
                    let bValue = b.find('td:nth-child(' + columnIdx + ')').data('sort-value')

                    if (typeof aValue === 'string' && typeof bValue === 'string') {
                        return aValue.localeCompare(bValue)
                    }

                    return parseInt(bValue) - parseInt(aValue)
                })

                break;
            }
        }

        rows.forEach(row => {
            row.appendTo(this.$dom.rowsContainer)
        })
    }

}

// TODO
// registerJQueryComponent(SortableTable, '.sortable-table')